import React from 'react';
import { VacationIcon } from '../../../../utils/vacation';

const Header = () => {
    return (
        <div className="flex items-center gap-2">
            <div className="bg-buttoncolor p-3 rounded-full mt-4 mr-3">
                <VacationIcon className="" size={24} />
            </div>
            <div className="mt-4">
                <h1 className="text-black font-roboto-mono text-xl font-bold leading-[31.65px]">
                    Traveller Profiles
                </h1>
                <p className="text-gray font-quicksand text-[15px] font-normal leading-[18.75px] mt-1 ">
                    Monitor and manage all packing lists created by travelers
                </p>
            </div>
        </div>
    );
}; 

export default Header;
 